import React from 'react';
import NumberFormat, { InputAttributes } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  max?: number;
}

export const NumberFormatCustom = React.forwardRef<
  NumberFormat<InputAttributes>,
  CustomProps
>(function NumberFormatCustom(props, ref) {
  const { onChange, max, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      isAllowed={(values) => {
        const { floatValue } = values;

        return (
          floatValue === undefined || max === undefined || floatValue <= max
        );
      }}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      type="text"
      thousandsGroupStyle="thousand"
      thousandSeparator=","
    />
  );
});
